import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';

import { serializeMiscPurchaseOrderUpdate } from './serialize';

/** PATCH `/srm/misc-purchase-order/{id}`。僅 DRAFT，含 updatedAt。 */
export async function updateMiscPurchaseOrder(id, payload) {
  const { data: raw } = await request.patch(
    `/srm/misc-purchase-order/${id}`,
    serializeMiscPurchaseOrderUpdate(payload),
  );
  return parseVer4DetailResponse(raw);
}
